import flag_da_dk from "../../static/flags/da-DK.svg";
import flag_de_de from "../../static/flags/de-DE.svg";
import flag_en_au from "../../static/flags/en-AU.svg";
import flag_en_ca from "../../static/flags/en-CA.svg";
import flag_en_gb from "../../static/flags/en-GB.svg";
import flag_en_nz from "../../static/flags/en-NZ.svg";
import flag_en_us from "../../static/flags/en-US.svg";
import flag_es_es from "../../static/flags/es-ES.svg";
import flag_fi_fi from "../../static/flags/fi-FI.svg";
import flag_fr_ca from "../../static/flags/fr-CA.svg";
import flag_fr_fr from "../../static/flags/fr-FR.svg";
import flag_ja_jp from "../../static/flags/ja-JP.svg";
import flag_ko_kr from "../../static/flags/ko-KR.svg";
import flag_nb_no from "../../static/flags/nb-NO.svg";
import flag_nl_nl from "../../static/flags/nl-NL.svg";
import flag_pl_pl from "../../static/flags/pl-PL.svg";
import flag_sv_se from "../../static/flags/sv-SE.svg";
import flag_fr_be from "../../static/flags/fr-BE.svg";
import flag_nl_be from "../../static/flags/nl-BE.svg";


export const flags = {
  flag_da_dk,
  flag_de_de,
  flag_en_au,
  flag_en_ca,
  flag_en_gb,
  flag_en_nz,
  flag_en_us,
  flag_es_es,
  flag_fi_fi,
  flag_fr_ca,
  flag_fr_fr,
  flag_ja_jp,
  flag_ko_kr,
  flag_nb_no,
  flag_nl_nl,
  flag_pl_pl,
  flag_sv_se,
  flag_fr_be,
  flag_nl_be,
};
